// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1fxnt","ranges":"BmiRanges_ranges__1aWcd"};